if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-drawer');

      this.hideErrors = this.dataset.hideErrors === 'true';
      
      // Track which button was clicked
      this.clickedButtonType = null;
      this.setupButtonClickHandlers();
    }
    
    setupButtonClickHandlers() {
      // Attach click handlers to all submit buttons to track which one was clicked
      const submitButtons = this.querySelectorAll('button[type="submit"]');
      submitButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          // Store which button was clicked
          if (button.classList.contains('product-checkout-btn')) {
            this.clickedButtonType = 'checkout';
          } else {
            this.clickedButtonType = 'add-to-cart';
          }
        });
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let wrapper = this.closest('.product');
      const fieldSets = Array.from(wrapper.querySelectorAll("fieldset"));
      let flag = false;
      fieldSets.forEach(element => {
        let value = Array.from(element.querySelectorAll("input")).find((radio) => radio.checked);
        if (!value) {
          flag = true;
        }
      });
      if (flag) {
        let error = this.querySelector('.product-form__error-message-wrapper');
        error.querySelector('.product-form__error-message').innerHTML = "Please select size";
        error.removeAttribute('hidden');
        return;
      }
      
      // Check which button was clicked using the stored value from click handler
      const isCheckoutButton = this.clickedButtonType === 'checkout';
      
      // Reset for next time
      this.clickedButtonType = null;
      
      // Get the submit button that was clicked (checkout button or regular add to cart)
      let submitButton = null;
      if (isCheckoutButton) {
        submitButton = this.querySelector('button.product-checkout-btn[type="submit"]');
      } else {
        submitButton = this.querySelector('button[type="submit"]:not(.product-checkout-btn)');
      }
      
      // Fallback to first submit button if not found
      if (!submitButton) {
        submitButton = this.querySelector('button[type="submit"]');
      }
      
      if (submitButton && submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      }

      // Check if fitted sheet checkbox exists and is checked
      // Find checkbox by class name - search in multiple locations
      let fittedCheckbox = null;
      // Search in product wrapper
      if (wrapper) {
        fittedCheckbox = wrapper.querySelector('.fitted-checkbox-input');
      }
      // Search in buy-buttons-wrapper (parent of product-form)
      if (!fittedCheckbox) {
        let buyButtonsWrapper = this.closest('.buy-buttons-wrapper');
        if (!buyButtonsWrapper && this.parentElement) {
          buyButtonsWrapper = this.parentElement.closest('.buy-buttons-wrapper');
        }
        if (buyButtonsWrapper) {
          fittedCheckbox = buyButtonsWrapper.querySelector('.fitted-checkbox-input');
        }
      }
      // Search in parent element
      if (!fittedCheckbox && this.parentElement) {
        fittedCheckbox = this.parentElement.querySelector('.fitted-checkbox-input');
      }
      // Fallback to document search
      if (!fittedCheckbox) {
        fittedCheckbox = document.querySelector('.fitted-checkbox-input');
      }
      const isFittedSelected = fittedCheckbox && fittedCheckbox.checked;
      const fittedVariantId = isFittedSelected ? fittedCheckbox.getAttribute('data-id') : null;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // If fitted sheet is selected, we need to add both items
      if (isFittedSelected && fittedVariantId) {
        // Get or create bundle ID from cookie
        const bundleId = this.getOrCreateBundleId();
        // Add bundle properties to main product
        formData.append('properties[_type]', 'master');
        formData.append('properties[_bundle]', 'true');
        formData.append('properties[_bedsheet]', bundleId);
        
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        // First, add the main product
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            $(document).trigger('product-form-responsed', [response]);

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);
              if (submitButton) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              }
              return;
            }

            // Now add the fitted sheet as a child
            const fittedFormData = new FormData();
            fittedFormData.append('id', fittedVariantId);
            fittedFormData.append('quantity', formData.get('quantity') || '1');
            fittedFormData.append('properties[_type]', 'child');
            fittedFormData.append('properties[_bundle]', 'true');
            fittedFormData.append('properties[_bedsheet]', bundleId);
            
            // Add fitted bedsheet size if provided
            // Find input by name attribute - search in multiple locations
            let fittedSheetSizeInput = null;
            // Search in product wrapper
            if (wrapper) {
              fittedSheetSizeInput = wrapper.querySelector('input[name="fitted-sheet-info"]');
            }
            // Search in buy-buttons-wrapper (parent of product-form)
            if (!fittedSheetSizeInput) {
              let buyButtonsWrapper = this.closest('.buy-buttons-wrapper');
              if (!buyButtonsWrapper && this.parentElement) {
                buyButtonsWrapper = this.parentElement.closest('.buy-buttons-wrapper');
              }
              if (buyButtonsWrapper) {
                fittedSheetSizeInput = buyButtonsWrapper.querySelector('input[name="fitted-sheet-info"]');
              }
            }
            // Search in parent element
            if (!fittedSheetSizeInput && this.parentElement) {
              fittedSheetSizeInput = this.parentElement.querySelector('input[name="fitted-sheet-info"]');
            }
            // Fallback to document search
            if (!fittedSheetSizeInput) {
              fittedSheetSizeInput = document.querySelector('input[name="fitted-sheet-info"]');
            }
            if (fittedSheetSizeInput && fittedSheetSizeInput.value.trim() !== '') {
              fittedFormData.append('properties[Fitted Bedsheet Size]', fittedSheetSizeInput.value.trim());
            }
            
            fittedFormData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
            fittedFormData.append('sections_url', window.location.pathname);

            const fittedConfig = fetchConfig('javascript');
            fittedConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete fittedConfig.headers['Content-Type'];
            fittedConfig.body = fittedFormData;

            return fetch(`${routes.cart_add_url}`, fittedConfig);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: fittedVariantId, errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);
              if (submitButton) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              }
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            
            // Redirect to checkout if checkout button was clicked
            if (isCheckoutButton) {
              window.location.href = '/checkout';
              return;
            }
            
            this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      } else {
        // Normal add to cart without bundle
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            $(document).trigger('product-form-responsed', [response]);

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);
              if (submitButton) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              }
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
            
            // Redirect to checkout if checkout button was clicked
            if (isCheckoutButton) {
              window.location.href = '/checkout';
              return;
            }
            
            this.cartNotification.renderContents(response);

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      }
    }

    getOrCreateBundleId() {
      const cookieName = '_bundle_id_counter';
      let bundleCounter = this.getCookie(cookieName);
      
      if (!bundleCounter) {
        bundleCounter = 1;
      } else {
        bundleCounter = parseInt(bundleCounter) + 1;
      }
      
      // Set cookie with the new counter value (expires in 365 days)
      this.setCookie(cookieName, bundleCounter, 365);
      
      return bundleCounter;
    }

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
